module.exports = "/static/media/payment_logo--mastercard.82d687ea.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/payment_logo--mastercard.svg
// module id = 1723
// module chunks = 0